import React, { useEffect } from 'react'
import { func, object, string } from 'prop-types'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import CartaoCreditoForm from '../../../components/CartaoCreditoForm/CartaoCreditoForm'
import { useCartaoCredito } from '../../../contexts/CartaoCreditoContext'
import { ADICIONAR_NOVO_CARTAO, ID_ADICIONAR_NOVO_CARTAO } from '../constantsFluxosPagamento'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import { useGlobal } from '../../../contexts/GlobalContext'


const WrapperNovoCartao = styled.div`
  max-width: 450px;
  position: relative;
  width: 100%;

  h4 {
    ${StyleGuide.tipografia.textoDefault}
    ${StyleGuide.boldFonte}
    margin: 20px 0 10px;
  }
`

const EscolhaNovoCartao = ( { idCartaoDeCreditoSelecionado, novoCartaoCredito, setNovoCartaoCredito, setIdCartaoDeCreditoSelecionado } ) => {
  const { cartoesCadastrados, cartaoVigente, loading } = useCartaoCredito()
  const { setValidCaptcha, captcha } = useGlobal()

  useEffect( () => {
    if ( cartoesCadastrados && ( !cartoesCadastrados.length || isEmptyObject( cartaoVigente ) ) ) {
      setIdCartaoDeCreditoSelecionado( ID_ADICIONAR_NOVO_CARTAO )
    }
  }, [ cartoesCadastrados, idCartaoDeCreditoSelecionado, novoCartaoCredito ] )

  useEffect( () => {
    if ( captcha === null ) {
      setValidCaptcha( false )
    } else {
      setValidCaptcha( true )
    }
  }, [ captcha ] )

  useEffect( () => {
    setValidCaptcha( false )
  }, [] )

  return (
    <WrapperNovoCartao>
      <h4>{ ADICIONAR_NOVO_CARTAO }</h4>
      <CartaoCreditoForm
        loading={ loading }
        onConfirmar={ cartaoRetornado => setNovoCartaoCredito( cartaoRetornado ) }
      />
    </WrapperNovoCartao>
  )
}

EscolhaNovoCartao.propTypes = {
  'idCartaoDeCreditoSelecionado': string,
  'novoCartaoCredito': object.isRequired,
  'setIdCartaoDeCreditoSelecionado': func.isRequired,
  'setNovoCartaoCredito': func.isRequired
}

EscolhaNovoCartao.defaultProps = {
  'idCartaoDeCreditoSelecionado': null
}

export default EscolhaNovoCartao
